var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.setsText)?_c('label-base',{staticClass:"gc-label-reps"},[_c('text-body-extra-small',{attrs:{"lineHeight":'multi'}},[_vm._v(" "+_vm._s(_vm.setsText)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }